import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheFirstSip from "./sections/TheFirstSip";
import TheLensTheMap from "./sections/TheLensTheMap";
import IslandRhythmsCuratedEscapes from "./sections/IslandRhythmsCuratedEscapes";
import ReadyToScaleYourVision from "./sections/ReadyToScaleYourVision";
import VoicesFromTheTrail from "./sections/VoicesFromTheTrail";
import GlobalSnapshots from "./sections/GlobalSnapshots";
import ExperienceInquiry from "./sections/ExperienceInquiry";
import MidnightRunnersCollection from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheFirstSip />
      <TheLensTheMap />
      <IslandRhythmsCuratedEscapes />
      <ReadyToScaleYourVision />
      <VoicesFromTheTrail />
      <GlobalSnapshots />
      <ExperienceInquiry />
      <MidnightRunnersCollection />
    </div>;
}